/**
 * Template: Register
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the register form page functionality.
 *
 * @namespace register
 */
import {on} from '~/helpers/utils';
import '../../../styles/templates/customers/register.scss';
import '../../../styles/sections/login-block.scss';
import '../../../styles/sections/login-form.scss';

/**
 * DOM selectors.
 */
const selectors = {
  registerForm: '#create_customer',
};

document.addEventListener('DOMContentLoaded', () => {
  localStorage.removeItem('registerForm');

  /**
   * DOM Node selectors.
   */
  const nodeSelectors = {
    registerForm: document.querySelector(selectors.registerForm),
  };

  on('submit', nodeSelectors.registerForm, () => handleRegisterDatalayer());

  /**
   * Handle new localStorage element to check register form.
   */
  function handleRegisterDatalayer() {
    localStorage.setItem('registerForm', 'step2');
  }
});
